import { baseApi } from './baseApi';

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get settings
    getSettings: builder.query({
      query: () => ({
        url: 'setting/get',
        method: 'GET',
      }),
      providesTags: ['Settings'],
    }),

    // Update settings
    editSettings: builder.mutation({
      query: (body) => ({
        url: 'setting/update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),

    // Create supporter
    createSupporter: builder.mutation({
      query: (body) => ({
        url: 'setting/create-supporter',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),

    // Delete supporter
    deleteSupporter: builder.mutation({
      query: (supporterId) => ({
        url: `setting/delete-supporter/${supporterId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Settings'],
    }),

    // Create donut
    createDonut: builder.mutation({
      query: (body) => ({
        url: 'setting/create-donut',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const {
  useGetSettingsQuery,
  useEditSettingsMutation,
  useCreateSupporterMutation,
  useDeleteSupporterMutation,
  useCreateDonutMutation,
} = settingsApi;